import { IConfigStorage } from "../../../../Common/IConfigStorage";
import { IDataDefinition } from "../../../../Common/Data/Definitions/IDataDefinition";
import { ValidationIssue } from "../../../../Common/IDesignValidationProvider";
import type { AppGlueAny } from "../../../../Common/AppGlueAny";

export enum ValueRuleCellType {
    SINGLE = "single",
    MULTIPLE = "multiple",
    IGNORE = "AppGlueAny",
    MISSING = "missing",
}

export class ValueRuleCell implements IConfigStorage {
    static IGNORE_CELL_VALUE = "(( any ))";
    static MISSING_CELL_VALUE = null;

    _columnId: string;
    values: AppGlueAny | AppGlueAny[] = null;

    constructor(columnId: string) {
        this._columnId = columnId;
    }

    get cellType(): ValueRuleCellType {
        if (this.values === ValueRuleCell.IGNORE_CELL_VALUE) {
            return ValueRuleCellType.IGNORE;
        } else if (Array.isArray(this.values) && typeof this.values !== "string") {
            return ValueRuleCellType.MULTIPLE;
        } else if (this.values === ValueRuleCell.MISSING_CELL_VALUE) {
            return ValueRuleCellType.MISSING;
        }

        return ValueRuleCellType.SINGLE;
    }

    set cellType(type: ValueRuleCellType) {
        if (type === ValueRuleCellType.IGNORE) {
            this.values = ValueRuleCell.IGNORE_CELL_VALUE;
        } else if (type === ValueRuleCellType.MISSING) {
            this.values = ValueRuleCell.MISSING_CELL_VALUE;
        } else if (type === ValueRuleCellType.MULTIPLE) {
            if (this.cellType === ValueRuleCellType.SINGLE) {
                this.values = [this.values];
            } else {
                this.values = [];
            }
        } else {
            if (this.cellType === ValueRuleCellType.MULTIPLE) {
                this.values = this.values[0];
            } else {
                this.values = undefined;
            }
        }
    }

    getStorageData(): object {
        let d = {};
        Reflect.set(d, "_columnId", this._columnId);
        Reflect.set(d, "values", this.values);
        return d;
    }

    setStorageData(data: object): void {
        this._columnId = Reflect.get(data, "_columnId");
        this.values = Reflect.get(data, "values");
    }

    validateCellData(datadef: IDataDefinition): ValidationIssue[] {
        let issues: ValidationIssue[] = [];
        if (this.values === null || this.values === undefined) {
            issues.push(new ValidationIssue("Value required"));
        } else if (this.values !== ValueRuleCell.IGNORE_CELL_VALUE) {
            if (Array.isArray(this.values)) {
                for (let v of this.values) {
                    if (datadef.verifyValueType(v)) {
                        issues.push(new ValidationIssue("Invalid data type"));
                    }
                }
            } else if (datadef.verifyValueType(this.values)) {
                issues.push(new ValidationIssue("Invalid data type"));
            }
        }

        return issues;
    }
}
